module.exports = __webpack_public_path__ + "img/vertical_3_6_6005.5ace2235.png";